import { render } from "./XIconSolidLink.vue?vue&type=template&id=fe9b9712"
import script from "./XIconSolidLink.vue?vue&type=script&lang=js"
export * from "./XIconSolidLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidLink.vue"]])

export default __exports__